import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route, RouterModule } from '@angular/router';
import { FullCalendarModule } from '@fullcalendar/angular';

import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NgxsModule } from '@ngxs/store';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { AppointmentQuestionaireComponent } from './components/appointment-questionaire/appointment-questionaire.component';
import { EmployeeDayComponent } from './containers/employee-day/employee-day.component';
import { AddEmployeeAppointmentComponent } from './components/add-employee-appointment/add-employee-appointment.component';
import { AddEmployeeAppointmentUserComponent } from './components/add-employee-appointment-user/add-employee-appointment-user.component';
import { AppointmentSearchComponent } from './components/appointment-search/appointment-search.component';
import { ngxPermissionsGuard, NgxPermissionsModule } from 'ngx-permissions';
import { AppointmentResourceOrderComponent } from './components/appointment-resource-order/appointment-resource-order.component';
import { AddEmpoyeeMobileAppointmentComponent } from './components/add-empoyee-mobile-appointment/add-empoyee-mobile-appointment.component';
import { EmployeeMobileDayComponent } from './containers/employee-mobile-day/employee-mobile-day.component';
import { AppointmentState } from './appointment.state';
import { EventTooltipComponent } from './components/event-tooltip/event-tooltip.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '@beautyapp/shared';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DisableReasonComponent } from './components/disable-reason/disable-reason.component';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { AppointmentsComponent } from './containers/appointments/appointments.component';
import { DayGridEmployeeComponent } from './containers/day-grid-employee/day-grid-employee.component';
import { EmployeeState } from '@beautyapp/core';
import { NzPopoverModule } from 'ng-zorro-antd/popover';

export const appointmentRoutes: Route[] = [
  {
    path: 'day',
    data: {
      permissions: {
        only: ['Admin', 'Manager', 'Administrator'],
        except: ['Employee'],
        redirectTo: '/dashboard',
      },
    },
    canActivate: [ngxPermissionsGuard],
    loadComponent: () =>
      import('./containers/day-grid/day-grid.component').then(
        (m) => m.DayGridComponent
      ),
  },
  {
    path: 'day/forEmployee/:userId',
    data: {
      permissions: {
        only: ['Admin', 'Manager', 'Administrator'],
        except: ['Employee'],
        redirectTo: '/dashboard',
      },
    },
    canActivate: [ngxPermissionsGuard],
    component: DayGridEmployeeComponent,
  },
  {
    path: 'day/employee',
    data: {
      permissions: {
        only: ['Employee'],
        redirectTo: '/dashboard',
      },
    },
    canActivate: [ngxPermissionsGuard],
    component: EmployeeDayComponent,
  },
  {
    path: 'day/employee/:userId',
    data: {
      permissions: {
        only: ['Admin', 'Manager', 'Administrator'],
        except: ['Employee'],
        redirectTo: '/dashboard',
      },
    },
    canActivate: [ngxPermissionsGuard],
    component: EmployeeDayComponent,
  },
  {
    path: 'day/mobile',
    data: {
      permissions: {
        only: ['Employee'],
        redirectTo: '/',
      },
    },
    canActivate: [ngxPermissionsGuard],
    component: EmployeeMobileDayComponent,
  },
  {
    path: 'all',
    data: {
      permissions: {
        only: ['Admin', 'Administrator', 'Manager'],
        redirectTo: '/dashboard',
      },
    },
    canActivate: [ngxPermissionsGuard],
    component: AppointmentsComponent,
  },
  {
    path: 'online-booking',
    data: {
      permissions: { only: ['Admin', 'Manager'], redirectTo: '/dashboard' },
    },
    canActivate: [ngxPermissionsGuard],
    loadComponent: () =>
      import('./containers/online-booking/online-booking.component').then(
        (m) => m.OnlineBookingComponent
      ),
  },
  {
    path: 'day-new',
    data: {
      permissions: {
        only: ['Admin', 'Administrator', 'Manager'],
        redirectTo: '/dashboard',
      },
    },
    canActivate: [ngxPermissionsGuard],
    loadComponent: () =>
      import(
        './containers/scheduler-calendar/scheduler-calendar.component'
      ).then((m) => m.SchedulerCalendarComponent),
  },
  {
    path: 'room-calendar',
    data: {
      permissions: {
        only: ['Admin', 'Administrator', 'Manager'],
        redirectTo: '/dashboard',
      },
    },
    canActivate: [ngxPermissionsGuard],
    loadComponent: () =>
      import('./containers/room-scheduler/room-scheduler.component').then(
        (m) => m.RoomSchedulerComponent
      ),
  },
];
